import {MUTATION_KEYS, QUERY_KEYS} from '@/queryClient'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {httpEditRank} from '../services/rank.http'

export const useEditRank = ({onSuccess, rankId}: {onSuccess: () => void; rankId: string}) => {
    const client = useQueryClient()
    return useMutation({
        mutationKey: [MUTATION_KEYS.EDIT_RANK],
        mutationFn: (data: FormData) => httpEditRank(data, rankId),
        onSuccess: () => {
            onSuccess()
            client.invalidateQueries({queryKey: [QUERY_KEYS.RANKING_LIST]})
        }
    })
}
